import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ALL_USERS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllUsersDataActionTypes } from './types';
import userApi from 'src/utils/api/userApi';

export const loadAllUsers =
  (): ThunkAction<Promise<void>, State, null, AllUsersDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ALL_USERS + REQUEST });
    try {
      const payload = await userApi.loadAllUsers();
      dispatch({ type: ALL_USERS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_USERS + FAILURE, error });
    }
  };
